import lamejs from 'lamejs';

function deinterleave (src, stride) {
	if (stride == null) stride = 2

	var planar = Array(src.length), channel, offset, clen = Math.floor(src.length/stride)

	for (var i = 0, l = src.length; i < l; i++) {
		channel = i % stride
		offset = Math.floor(i / stride)

		planar[channel * clen + offset] = src[i]
	}

	for (i = 0; i < l; i++) {
		src[i] = planar[i]
	}

	return src
}

export const endodeArrayBufferToMp3 = async (name, interleavedArrayBuffer) => {

  const deleaved = deinterleave(interleavedArrayBuffer, 2);

  const channels = 2; //1 for mono or 2 for stereo
  const sampleRate = 48000; //44.1khz (normal mp3 samplerate)
  const kbps = 128; //encode 128kbps mp3
  const mp3encoder = new lamejs.Mp3Encoder(channels, sampleRate, kbps);
  var mp3Data = [];

  const left = deleaved.slice(0, (deleaved.length / 2) - 1); //one second of silence (get your data from the source you have)
  const right = deleaved.slice((deleaved.length / 2) -1, deleaved.length -1); //one second of silence (get your data from the source you have)
  const sampleBlockSize = 1152; //can be anything but make it a multiple of 576 to make encoders life easier

for (var i = 0; i < left.length; i += sampleBlockSize) {
  let leftChunk = left.subarray(i, i + sampleBlockSize);
  let rightChunk = right.subarray(i, i + sampleBlockSize);
  var mp3buf = mp3encoder.encodeBuffer(leftChunk, rightChunk);
  if (mp3buf.length > 0) {
    mp3Data.push(mp3buf);
  }
}
  mp3buf = mp3encoder.flush();   //finish writing mp3

  if (mp3buf.length > 0) {
      mp3Data.push(new Int8Array(mp3buf));
  }

  var blob = new Blob(mp3Data, {type: 'audio/mp3'});
  var url = window.URL.createObjectURL(blob);

  return url;
}


export const decodeCompressedAudio = (compressedArrayBuffer) => {
    return new Promise((resolve, reject) => {
        let decoderWorker = new Worker(`${process.env.PUBLIC_URL}/lib/superpowered/DecoderWorker.js`);

        // trackLoaderWorker.ontransfer = function(message) {
        //     this.transfer(message.transfer, trackLoaderWorker);
        // }.bind(this);

        decoderWorker.onmessage = function(message) {
            resolve(message.data);
            decoderWorker.terminate();
        };

        decoderWorker.postMessage(compressedArrayBuffer, [compressedArrayBuffer]);
    });
        
}


// Returns Uint8Array of WAV bytes
export function getWavBytes(buffer, options) {
    const type = options.isFloat ? Float32Array : Uint16Array;
    const numFrames = buffer.byteLength / type.BYTES_PER_ELEMENT;
  
    const headerBytes = getWavHeader(Object.assign({}, options, { numFrames }));
    const wavBytes = new Uint8Array(headerBytes.length + buffer.byteLength);
  
    // prepend header, then add pcmBytes
    wavBytes.set(headerBytes, 0);
    wavBytes.set(new Uint8Array(buffer), headerBytes.length);
  
    return wavBytes;
  }


  // adapted from https://gist.github.com/also/900023
// returns Uint8Array of WAV header bytes
export function getWavHeader(options) {
    const numFrames = options.numFrames;
    const numChannels = options.numChannels || 2;
    const sampleRate = options.sampleRate || 44100;
    const bytesPerSample = options.isFloat ? 4 : 2;
    const format = options.isFloat ? 3 : 1;
  
    const blockAlign = numChannels * bytesPerSample;
    const byteRate = sampleRate * blockAlign;
    const dataSize = numFrames * blockAlign;
  
    const buffer = new ArrayBuffer(44);
    const dv = new DataView(buffer);
  
    let p = 0;
  
    function writeString(s) {
      for (let i = 0; i < s.length; i++) {
        dv.setUint8(p + i, s.charCodeAt(i));
      }
      p += s.length;
    }
  
    function writeUint32(d) {
      dv.setUint32(p, d, true);
      p += 4;
    }
  
    function writeUint16(d) {
      dv.setUint16(p, d, true);
      p += 2;
    }
  
    writeString("RIFF"); // ChunkID
    writeUint32(dataSize + 36); // ChunkSize
    writeString("WAVE"); // Format
    writeString("fmt "); // Subchunk1ID
    writeUint32(16); // Subchunk1Size
    writeUint16(format); // AudioFormat
    writeUint16(numChannels); // NumChannels
    writeUint32(sampleRate); // SampleRate
    writeUint32(byteRate); // ByteRate
    writeUint16(blockAlign); // BlockAlign
    writeUint16(bytesPerSample * 8); // BitsPerSample
    writeString("data"); // Subchunk2ID
    writeUint32(dataSize); // Subchunk2Size
  
    return new Uint8Array(buffer);
  }